import { Box } from '@chakra-ui/react';
import React, { useState } from 'react';
import OTPModal from '../auth/OTPModal';
// import { sendEmailOtpV2, verifyEmailOtpV2 } from '../../../api/utils/api/v2/profile';
import { useMutation } from 'react-query';
// import { axiosErrorHandler } from '../../../api/utils/error';
import { signIn, updateUserProfile, verifyEmailOtp, verifySignInOtp } from '../../../apis/V2/auth';
import { useUser, useUserProfile } from '../../../hooks/V2/useUser';
import EmailEdit from './EmailEdit';
import useSnackBar from './Snackbar';
import { axiosErrorHandler } from '../../../apis/axios';
import { sendEmailVerificationOTP } from '../../../apis/auth';
import { useDomainConfig } from '../../../hooks/useDomainConfig';

interface Props {
	showEmailOtpModal: boolean;
	setShowEmailOtpModal: React.Dispatch<React.SetStateAction<boolean>>;
	updatedEmail?: string;
	setShowUpdateEmailModal: React.Dispatch<React.SetStateAction<boolean>>;
}
const EmailVerifyModalV2 = ({ updatedEmail, showEmailOtpModal, setShowEmailOtpModal, setShowUpdateEmailModal }: Props) => {
	const { data: domainConfig, isLoading, isError } = useDomainConfig({ uiHost: window.location.host });

	const onOTPModalClose = () => {
		setShowEmailOtpModal(false);
		refetchProfile();
	};
	const { isLoading: profileLoading } = useUserProfile();
	const { data: profile, refetch: refetchProfile } = useUser();

	const handleEmailEditClick = () => {
		setShowEmailOtpModal(false);
		setShowUpdateEmailModal(true);
	};
	const snackbar = useSnackBar();
	const { mutate: sendEmailOtpMutate, isLoading: sendEmailOtpLoading } = useMutation(signIn, {
		onSuccess: data => {
			snackbar.success('Otp sent on email!');
			if (!showEmailOtpModal) {
				setShowEmailOtpModal(true);
			}
		},
		onError: error => {
			const e = axiosErrorHandler(error);
			if (typeof e === 'object' && 'message' in e) {
				snackbar.error(e.message);
			} else {
				snackbar.error('Something went wrong');
			}
		},
	});
	const { mutate: verifyEmailOtpMutate, isLoading: verifyEmailOtpLoading } = useMutation(verifyEmailOtp, {
		onSuccess: data => {
			snackbar.success('Email verified successfully!');
			if (showEmailOtpModal) {
				setShowEmailOtpModal(false);
				refetchProfile();
			}
		},
		onError: error => {
			const e = axiosErrorHandler(error);
			if (typeof e === 'object' && 'message' in e) {
				snackbar.error(e.message);
			} else {
				snackbar.error('Something went wrong');
			}
		},
	});

	return (
		<Box>
			<OTPModal
				isOpen={showEmailOtpModal}
				onClose={() => {
					// console.log("clearing timers due to otp modal closed!");
					onOTPModalClose();
				}}
				title={'Email Verification'}
				primaryText={`Please enter the OTP to verify your email address`}
				secondaryText={<EmailEdit handleEmailEditClick={handleEmailEditClick} email={updatedEmail ? updatedEmail : profile?.email} />}
				otpLength={6}
				timeGap={60}
				onComplete={value => {
					//   handleVerifyOTPEmailVerify(value);
					verifyEmailOtpMutate({ otp: value });
					refetchProfile();
				}}
				onResendCallback={async () => {
					//   handleSendOTPEmailVerify();
					sendEmailOtpMutate({ email: updatedEmail || profile?.email, domainKey: domainConfig?.key });
				}}
				loading={profileLoading || sendEmailOtpLoading || verifyEmailOtpLoading}
			/>
		</Box>
	);
};

export default EmailVerifyModalV2;
